import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import {
  parseCsvLocalDateTime,
  parseEnumEmptyString,
  parseBooleanValue,
} from '~/prix/utils/bulk/csvValueParsers'
import clearString from '~/prix/utils/bulk/clearString'

const dentalAttendance: Dataset = {
  schema: 'public_health',
  table: 'dental_attendance',
  columnTransformMap: {
    original_id: original => clearString(original as string),
    data_source_id: original => original,
    attendance_start_datetime: original => parseCsvLocalDateTime(original as string),
    attendance_end_datetime: original => parseCsvLocalDateTime(original as string),
    citizen_original_id: original => clearString(original as string),
    professional_original_id: original => clearString(original as string),
    type_of_attendance: original => parseEnumEmptyString(original as string),
    upper_total_prosthesis_usage: original => parseBooleanValue(original as string),
    lower_total_prosthesis_usage: original => parseBooleanValue(original as string),
    orthodontic_appliance_usage: original => parseBooleanValue(original as string),
    retention_appliance_usage: original => parseBooleanValue(original as string),
    consultation_type: original => parseEnumEmptyString(original as string),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default dentalAttendance
